export type ReaderType = 'theory-book' | 'work-book' | 'theory-work-book';
export const MIN_READER_PAGE_COUNT = 60;
export const MAX_READER_PAGE_COUNT = 640;
export const MAX_READER_TITLE_LENGTH = 255;
export const MAX_READER_SUBTITLE_LENGTH = 255;
export const MAX_READER_SCHOOL_NAME_LENGTH = 255;

export enum ReaderStatuses {
  Draft = 'draft',
  Generating = 'generating',
  Generated = 'generated',
  Processing = 'processing',
  Processed = 'processed',
  Ready = 'ready',
  Failed = 'failed',
  Archived = 'archived',
}

export type ReaderStatus = `${ReaderStatuses}`;

export interface Reader {
  id: string;
  externalId: string | null;
  arrangementCode: string;
  contentIdentifier: string;
  title: string;
  subTitle: string | null;
  description: string | null;
  methodCode: string;
  readerType: ReaderType;
  status: ReaderStatus;
  pageCount: number | null;
  schoolName: string | null;
  fileUrl: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  storeUrl: string | null;
  price: string | null;
}

export interface ManagementReader extends Reader {
  methodEan: string | null;
  actor: string;
}

export const readerTypes: Array<ReaderType> = [
  'theory-work-book',
  'theory-book',
  'work-book',
];

export const readerUnfinishedStates: Array<ReaderStatus> = [
  ReaderStatuses.Draft,
  ReaderStatuses.Generating,
];

export const readyForOrderStates: Array<ReaderStatus> = [
  ReaderStatuses.Processed,
  ReaderStatuses.Ready,
];

export const readerEditableState: Array<ReaderStatus> = [
  ReaderStatuses.Draft,
  ReaderStatuses.Generated,
  ReaderStatuses.Generating,
];

export const readerPollingState: Array<ReaderStatus> = [
  ReaderStatuses.Draft,
  ReaderStatuses.Generating,
  ReaderStatuses.Processing,
  ReaderStatuses.Processed,
];

export const deletableStates: Array<ReaderStatus> = [
  ReaderStatuses.Generated,
  ReaderStatuses.Failed,
  ReaderStatuses.Archived,
];
